import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Notifications.mock.json'

const notificationClient = new APIClient({
  baseURL: process.env.REACT_APP_NOTIFICATION_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    notificationClient,
    MOCK_RESPONSES,
  )({
    // 'get /user/notifications/unread-count': 200,
    // 'get /user/notifications': 200,
    // 'post /user/notifications/read': 200,
    // 'post /user/notifications/read-all': 200,
  })
}

export const getUnreadNotificationCount = accessToken =>
  notificationClient({
    method: 'get',
    url: '/user/notifications/unread-count',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

export const getAllNotifications = (accessToken, offset = '', limit = 5) =>
  notificationClient({
    url: `/user/notifications?limit=${limit}&offset=${encodeURIComponent(
      offset,
    )}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getNotification = (id, accessToken) =>
  notificationClient({
    url: '/user/notifications/read',
    method: 'post',
    data: {
      id,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postReadAllNotifications = accessToken =>
  notificationClient({
    url: '/user/notifications/read-all',
    method: 'post',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
